import React from 'react';
import i18n from 'i18next';
import { SwForm, SwInnerHtml, CommonUtils } from 'simplifyworks-core-ui';

export function getEavFields(fieldsDefinitions, propertyPrefix = 'person', sizeOverride) {
	if (!fieldsDefinitions) {
		return null;
	}

	return fieldsDefinitions.map(
		(def) => {
			let props = {};
			props.property = propertyPrefix + '.fieldValuesMap.' + def.key;
			props.label = i18n.language === 'en' ? def.labelEn : def.label;
			props.size = sizeOverride ?? def.layoutSize;
			props.validations = def.validations || null;
			if (props.validations) {
				const regex = /mask\((.*)\)/;
				const maskMatch = props.validations.match(regex);
				if (maskMatch) {
					props.validations = props.validations.replace(regex, 'mask(' + CommonUtils.encodeURIFull(maskMatch[1]) + ')');
				}
			}
			if (def.help) {
				props.help = <SwInnerHtml sanitizeArguments={{ADD_ATTR: ['target']}} content={i18n.language === 'en' ? def.helpEn : def.help } />;
			}
			if (def.enumDef) {
				props.options = {
					values: def.enumDef.map(v => v.value),
					labels: i18n.language === 'en' ? def.enumDef.map(v => v.labelEn) : def.enumDef.map(v => v.label)
				};
			}

			switch (def.dataType) {
				case 'STRING':
					return <SwForm.String {...props} key={def.key} />;
				case 'AREA':
					return <SwForm.String {...props} type='area' key={def.key} />;
				case 'NUMBER':
					return <SwForm.Number {...props} key={def.key} />;
				case 'DATE':
					return <SwForm.Datetime {...props} key={def.key} />;
				case 'BOOLEAN':
					return <SwForm.Boolean {...props} showNull={false} key={def.key} />;
				case 'ENUM':
					return <SwForm.Enum {...props} key={def.key} />;
				case 'MULTIENUM':
					return <SwForm.Enums {...props} key={def.key} />;
				case 'HTML':
					return <SwForm.Html {...props} key={def.key} />;
				case 'IMAGE':
					return <SwForm.Image {...props} key={def.key} />;
				default:
					console.error('Unknown field definition dataType ', def.dataType);
					return null;
			}
		}
	);
}
